// extracted by mini-css-extract-plugin
export default {"container":"pD-z","dimension":"qD-z","dimensionLabels":"rD-z"};